import { useSuspenseQuery } from '@suspensive/react-query';

import { useEnnismoreApiClientConfig } from '@/api';
import { getBookingServiceClient } from '@/booking/services/client';
import { useHotel } from '@/hotel';
import { useSessionId } from '@/session/use-session-id.hook';

export function useBookingPaymentProviderDetails({
  hotelReferenceId,
  bookingId,
}: {
  hotelReferenceId: string;
  bookingId: string;
}) {
  const config = useEnnismoreApiClientConfig();
  const hotel = useHotel(hotelReferenceId);
  const sessionId = useSessionId();

  return useSuspenseQuery({
    queryKey: ['payment-provider-details', bookingId],
    queryFn: async () => {
      const dialect = hotel?.dialect ?? 'ohip';
      const client = getBookingServiceClient(config, dialect);

      const { stripeDetails } = await client.getBookingPaymentMethodDetails({
        hotelReferenceId,
        bookingId,
        sessionId,
      });

      if (!stripeDetails) {
        throw new Error('No usable payment methods available for this booking');
      }

      return stripeDetails;
    },
    staleTime: Infinity,
  });
}
